import {Component, OnInit, Input, Output, EventEmitter, OnChanges} from '@angular/core';
import {Router} from '@angular/router';
import {RouterUtils} from '../../shared/utils';
import {AppServices} from '../../shared/services';

@Component({
    selector: 'related-alert',
    templateUrl: './related-alert.component.html',
    styleUrls : ['./related-alert.component.scss']
})


export class RelatedAlertComponent implements  OnInit, OnChanges {
    @Output() public routing: EventEmitter<any> = new EventEmitter();
    @Input() relatedAlert: any;
    params = { alrtNo: 0,
        viewType: 'detail'};
    private url: any;

    constructor(public _route: Router,
                private appService: AppServices) {
        this.url = this.appService.getUrls();
    }
    ngOnInit() {
    }

    ngOnChanges() {
    }

    routeAlert(alrtNo, evt?) {
        const isControlClick = evt.ctrlKey || evt.metaKey;
        this.params.alrtNo = alrtNo;
        //this.params.back = 'incident';

        // console.log(this.params);
        //const option = (JSON.stringify(this.params));
        const option = {
            alrtNo: this.params.alrtNo,
            viewType: 'detail'
        };

        if (isControlClick) {
            RouterUtils.newWindow(this.url.incident.alert, option);
        } else {
            RouterUtils.navigate(this._route, this.url.incident.alert, option);
        }

        //this._route.navigate([`/incident/alert/${option}`]);

    }
}



// WEBPACK FOOTER //
// ./src/app/components/related-alert/related-alert.component.ts